export const ENV = {
    appBaseUrl: process.env.REACT_APP_BASE_ADMIN_API,
    fileBaseUrl: process.env.REACT_APP_BACKEND_FILE_URL,
    openCageApiKey: process.env.REACT_PUBLIC_OPENCAGE_API_KEY,
    // appClientUrl: process.env.REACT_APP_BASE_URL,
    // serverUrl: process.env.REACT_APP_SERVER_URL,
    // Authorization: `Bearer ${process.env.REACT_APP_AUTHORIZATION}`,
    // x_access_token: JSON.parse(localStorage.getItem('token')),
    // x_auth_token: process.env.REACT_APP_X_AUTH_TOKEN,
    // adminPrivateKey: process.env.REACT_APP_ADMIN_PRIVATE_KEY,
    // file_Url: process.env.REACT_APP_BACKEND_FILE_URL,
    // appPageInsightsUrl: process.env.REACT_APP_BASE_API_PAGEINSIGHTS,
    // socketUrl: process.env.REACT_APP_NOTIFICATION_URL,

    encryptUserData(token) {
        // console.log(token);
        // console.log("token",token);

        // Accept multiple calling conventions:
        // - encryptUserData(token)
        // - encryptUserData(userObject, token, id)
        try {
            if (token && typeof token === 'object' && !Array.isArray(token)) {
                // Called as encryptUserData(userObject, token, id)
                const userObj = token;
                const resolvedToken = userObj?.access_token || userObj?.accessToken || userObj?.token;
                if (resolvedToken) {
                    localStorage.setItem('token', JSON.stringify(resolvedToken));
                }
                localStorage.setItem('user', JSON.stringify(userObj));
                return true;
            }

            // Called as encryptUserData(token)
            const onlyToken = token;
            if (onlyToken) {
                localStorage.setItem('token', JSON.stringify(onlyToken));
            }
            return true;
        } catch (e) {
            return false;
        }
    },

    getUserKeys(keys = null) {
        const userData = JSON.parse(localStorage.getItem('user'));
        return userData;
    },
    getToken() {
        const userData = localStorage.getItem('token');
        if (userData) {
            return userData;
        }
        return {};
    },

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
    },
    objectToQueryString(body) {
        const qs = Object.keys(body)
            .map((key) => `${key}=${body[key]}`)
            .join('&');
        return qs;
    },
};
